import React, { useState, useEffect, useContext } from 'react'
import { Header, Divider, Input, Segment, Button, Dropdown } from 'semantic-ui-react'
import FormLabel from '../../common/FormLabel'
import Result from '../../../common/repository/Result'
import { toast } from '../../common/Toast'
import RoleRepository from '../../../common/repository/RoleRespository';
import { Description } from '../../elements/Text'
import Role from '../../../models/Role'
import constants from '../../../common/constants';
import config from '../../../common/repository/config'
import LocalStorage from '../../../lib/LocalStorage'

function IncentiveSegment() {
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState<any[]>([]);
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
 
  const defaultRule = (state?: string) => {
    if(state === "mis") {
     return [
    
          { low: "", high: "", score: "" },
          { low: "", high: "", score: "" },
          { low: "", high: "", score: "" },
          { low: "", high: "", score: "" },
          { low: "", high: "", score: "" }
      

      ];
    } else {
      return [
    
          { low: "", high: "", score: "" },
          { low: "", high: "", score: "" },
          { low: "", high: "", score: "" },
          { low: "", high: "", score: "" }
      

      ];
    }

  }

  const [misData, setMisData] = useState({
    caseGenerated: defaultRule(),
    generationHygiene: defaultRule(),
    caseClosed: defaultRule(),
    closerHygiene: defaultRule(),
    incentive: defaultRule("mis"),
    deductionPerGeneration: "",
    deductionPerClosure: ""
  });

  const [zoData, setZoData] = useState({
    totalQcDone: defaultRule("mis"),
    successRate: defaultRule(),
    tat: defaultRule(),
    qcTat: defaultRule(),
    incentive: defaultRule("mis"),
    reinvestigationDeduction: ""
  });

  const [tlData, setTlData] = useState({
    fieldRatio: defaultRule(),
    teamRatio: defaultRule(),
    successRate: defaultRule(),
    tat: defaultRule(),
    incentive: defaultRule("mis")
  });

  const [caData, setCaData] = useState({
    totalClosedCases: defaultRule("mis"),
    hygiene: defaultRule("mis"),
    incentive: defaultRule("mis")
  });

  const [ohData, setOhData] = useState({
    fieldRatio: defaultRule(),
    teamRatio: defaultRule(),
    successRate: defaultRule(),
    tat: defaultRule(),
    incentive: defaultRule("mis"),
    reinvestigationDeduction: ""
  });

  const handleChange = (
    setter: any,
    state: any,
    section: string,
    index: number,
    field: "low" | "high" | "score",
    value: string
  ) => {
    const updated = [...state[section]];
    updated[index][field] = value;

    setter({
      ...state,
      [section]: updated
    });
  };

  const handleSingleField = (
    setter: any,
    state: any,
    field: string,
    value: string
  ) => {
    setter({
      ...state,
      [field]: value
    });
  };

  const mapRule = (item: any) => ({
    low_value: Number(item.low),
    high_value: Number(item.high),
    score: Number(item.score)
  });


  const buildPayload = () => {
    if (!selectedRole) return null;

    if (selectedRole.getTitle() === constants.roleTitle.mis) {
      return {
        roleId: selectedRole.getId(),
        incentiveConfig: {
          case_genrated_rule: misData.caseGenerated.map(mapRule),
          gerneration_hygine_percentage_rule:
            misData.generationHygiene.map(mapRule),
          case_closed_rule: misData.caseClosed.map(mapRule),
          closer_hygine_percentage_rule: misData.closerHygiene.map(mapRule),
          deduction_per_genration_error: Number(
            misData.deductionPerGeneration
          ),
          deduction_per_closer_error: Number(misData.deductionPerClosure),
          incentive_rules: misData.incentive.map(mapRule)
        }
      };
    }

    if (selectedRole.getTitle() === constants.roleTitle.tl) {
      return {
        roleId: selectedRole.getId(),
        incentiveConfig: {
          field_ratio_rule: tlData.fieldRatio.map(mapRule),
          team_ratio_rule: tlData.teamRatio.map(mapRule),
          sr_percentage_rule: tlData.successRate.map(mapRule),
          tat_percentage_rule: tlData.tat.map(mapRule),
          incentive_rules: tlData.incentive.map(mapRule)
        }
      };
    }

    if (selectedRole.getTitle() === constants.roleTitle.zo) {
      return {
        roleId: selectedRole.getId(),
        incentiveConfig: {
          // field_ratio_rule: zoData.fieldRatio.map(mapRule),
          // team_ratio_rule: zoData.teamRatio.map(mapRule),
          total_qc_done_rule: zoData.totalQcDone.map(mapRule),
          sr_percentage_rule: zoData.successRate.map(mapRule),
          tat_percentage_rule: zoData.tat.map(mapRule),
          qc_tat_percentage_rule: zoData.qcTat.map(mapRule),
          per_reinvestigation_deduction: Number(zoData.reinvestigationDeduction),
          incentive_rules: zoData.incentive.map(mapRule)
        }
      };
    }

    if (selectedRole.getTitle() === constants.roleTitle.oh) {
      return {
        roleId: selectedRole.getId(),
        incentiveConfig: {
          field_ratio_rule: ohData.fieldRatio.map(mapRule),
          team_ratio_rule: ohData.teamRatio.map(mapRule),
          sr_percentage_rule: ohData.successRate.map(mapRule),
          tat_percentage_rule: ohData.tat.map(mapRule),
          per_reinvestigation_deduction: Number(ohData.reinvestigationDeduction),
          incentive_rules: ohData.incentive.map(mapRule)
        }
      };
    }

    if (selectedRole.getTitle() === constants.roleTitle.ca) {
      return {
        roleId: selectedRole.getId(),
        incentiveConfig: {
          total_closed_cases_rules: caData.totalClosedCases.map(mapRule),
          hygine_rules: caData.hygiene.map(mapRule),
          incentive_rules: caData.incentive.map(mapRule),
        }
      };
    }
  };


  const handleSubmit = async () => {
    const payload = buildPayload();
    if (!payload) return toast.error("Select role");

    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN)
    try {
      setLoading(true);

      const res = await fetch(`${config.apiBaseURL}/incentive/addIncentiveConfig`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token || ""
       },
       body: JSON.stringify(payload)
      });

      const data = await res.json();
      toast.success(data.message);
    } catch (e) {
      toast.error(e as string);
    } finally {
      setLoading(false);
    }
  };

  const renderLabel = (index: number) => {
    switch (index) {
      case 0:
        return <h4 style={{color: "#9c9a9a"}}>Basic</h4>;
      case 1:
        return <h4 style={{color: "#9c9a9a"}}>Beginner</h4>;
      case 2:
        return <h4 style={{color: "#9c9a9a"}}>Intermediate</h4>;
      case 3:
        return <h4 style={{color: "#9c9a9a"}}>High</h4>;
      case 4:
        return <h4 style={{color: "#9c9a9a"}}>Excellent</h4>;
      default:
        return null;
    }
  };

  const userRoleRepo = new RoleRepository();

  const  fetchRole = async () => {
    setLoading(true);
    let data = await userRoleRepo.getRoles();
    if (data instanceof Result.Success) {
      const filteredRole = data.data.items.filter((role) => role.getTitle() === constants.roleTitle.zo || role.getTitle() === constants.roleTitle.tl || role.getTitle() === constants.roleTitle.ca || role.getTitle() === constants.roleTitle.oh || role.getTitle() === constants.roleTitle.mis)
      setUserRole(filteredRole);
    } else {
      toast.error( data.message ||"Something went wrong");
    }
    setLoading(false);
  };
  // type IncentiveCalculation =
  // | typeof misData
  // | typeof zoData
  // | typeof tlData
  // | typeof caData
  // | typeof ohData;

  const fetchData = async (role: any) => {

    try {
      setLoading(true); 
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      const res = await fetch(`${config.apiBaseURL}/incentive/getIncentiveConfig`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token || ""
       },
       body: JSON.stringify({roleId: role.id})
      });

      const data = await res.json();
      toast.success(data.message);
      
      if (data.data.items.length > 0) {
        const configs = data.data.items[0];
        const ic = configs.incentive_calculation;
        if (configs.role.name === constants.roleTitle.mis) {
          setMisData({
            caseGenerated: ic.case_genrated_rule.map(mapUI),
            generationHygiene: ic.gerneration_hygine_percentage_rule.map(mapUI),
            caseClosed: ic.case_closed_rule.map(mapUI),
            closerHygiene: ic.closer_hygine_percentage_rule.map(mapUI),
            incentive: ic.incentive_rules.map(mapUI),
            deductionPerGeneration: ic.deduction_per_genration_error,
            deductionPerClosure: ic.deduction_per_closer_error
          });
        }

        if (configs.role.name === constants.roleTitle.zo) {
          setZoData({
            // fieldRatio: ic.field_ratio_rule.map(mapUI),
            // teamRatio: ic.team_ratio_rule.map(mapUI),
            totalQcDone: ic.total_qc_done_rule?.map(mapUI) ?? defaultRule("mis"),
            successRate: ic.sr_percentage_rule.map(mapUI),
            tat: ic.tat_percentage_rule.map(mapUI),
            qcTat: ic.qc_tat_percentage_rule.map(mapUI),
            incentive: ic.incentive_rules.map(mapUI),
            reinvestigationDeduction: ic.per_reinvestigation_deduction
          });
        }

        if (configs.role.name === constants.roleTitle.oh) {
          setOhData({
            fieldRatio: ic.field_ratio_rule.map(mapUI),
            teamRatio: ic.team_ratio_rule.map(mapUI),
            successRate: ic.sr_percentage_rule.map(mapUI),
            tat: ic.tat_percentage_rule.map(mapUI),
            incentive: ic.incentive_rules.map(mapUI),
            reinvestigationDeduction: ic.per_reinvestigation_deduction
          });
        }

        if (configs.role.name === constants.roleTitle.ca) {
          setCaData({
            totalClosedCases: ic.total_closed_cases_rules.map(mapUI),
            hygiene: ic.hygine_rules.map(mapUI),
            incentive: ic.incentive_rules.map(mapUI)
          });
        }
        
        if (configs.role.name === constants.roleTitle.tl) {
          setTlData({
            fieldRatio: ic.field_ratio_rule.map(mapUI),
            teamRatio: ic.team_ratio_rule.map(mapUI),
            successRate: ic.sr_percentage_rule.map(mapUI),
            tat: ic.tat_percentage_rule.map(mapUI),
            incentive: ic.incentive_rules.map(mapUI)
          });
        }
      }
    } catch(e) {
      toast.error(e as string);
    } finally {
      setLoading(false);
    }
  }
  const mapUI = (r: any) => ({
    low: r?.low_value || "",
    high: r?.high_value || "",
    score: r?.score || ""
  });

  useEffect(() => {
    fetchRole();
  }, []);

  const roles = userRole.map((role) => {
    return { key: role.getId(), value: role.getId(), text: role.getTitle() };
  });

  return (
    <>
      <Description>Select a Role from the dropdown below</Description>
      <Dropdown
        selection
                loading={loading}
                value={selectedRole?.getId() || ""}
                placeholder="Select Role"
                onChange={(_, { value }) => {
                  const selectedRole = userRole.find(
                    (it) => it.getId() === value
                  );
                  if (selectedRole) {
                    setSelectedRole(selectedRole)
                  }
                  fetchData(selectedRole)
                }}
        options={roles}
      />
      <Segment basic >             
        
        {
          selectedRole?.getTitle() === constants.roleTitle.mis && 
          <>
            <FormLabel width="150px">
              <strong style={{fontSize:"1.5rem"}}>Case Generated</strong>
            </FormLabel>
            {misData.caseGenerated.map((item, index) => (
              <>
                {renderLabel(index) }
                <div key={index} style={{ display: "flex", gap: "10px" }}>
                  <Input
                    placeholder="Low"
                    value={item.low}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "caseGenerated",
                        index,
                        "low",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="High"
                    value={item.high}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "caseGenerated",
                        index,
                        "high",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="Score"
                    value={item.score}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "caseGenerated",
                        index,
                        "score",
                        e.target.value
                      )
                    }
                  />
                </div>
              </>
            ))}
            <Divider />

            <FormLabel width="150px">
              <strong style={{fontSize:"1.5rem"}}>Generation Hygiene</strong>
            </FormLabel>
            {misData.generationHygiene.map((item, index) => (
              <>
                {renderLabel(index) }
                <div key={index} style={{ display: "flex", gap: "10px" }}>
                  <Input
                    placeholder="Low"
                    value={item.low}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "generationHygiene",
                        index,
                        "low",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="High"
                    value={item.high}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "generationHygiene",
                        index,
                        "high",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="Score"
                    value={item.score}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "generationHygiene",
                        index,
                        "score",
                        e.target.value
                      )
                    }
                  />
                </div>
              </>
            ))}
            <Divider />
            
            <FormLabel width="150px">
              <strong style={{fontSize:"1.5rem"}}>Case Closed</strong>
            </FormLabel>
            {misData.caseClosed.map((item, index) => (
              <>
                {renderLabel(index) }
                <div key={index} style={{ display: "flex", gap: "10px" }}>
                  <Input
                    placeholder="Low"
                    value={item.low}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "caseClosed",
                        index,
                        "low",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="High"
                    value={item.high}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "caseClosed",
                        index,
                        "high",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="Score"
                    value={item.score}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "caseClosed",
                        index,
                        "score",
                        e.target.value
                      )
                    }
                  />
                </div>
              </>
            ))}
            <Divider />

            <FormLabel width="150px">
              <strong style={{fontSize:"1.5rem"}}>Closer Hygine</strong>
            </FormLabel>
            {misData.closerHygiene.map((item, index) => (
              <>
                {renderLabel(index) }
                <div key={index} style={{ display: "flex", gap: "10px" }}>
                  <Input
                    placeholder="Low"
                    value={item.low}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "closerHygiene",
                        index,
                        "low",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="High"
                    value={item.high}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "closerHygiene",
                        index,
                        "high",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="Score"
                    value={item.score}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "closerHygiene",
                        index,
                        "score",
                        e.target.value
                      )
                    }
                  />
                </div>
              </>
            ))}
            <Divider />

            <FormLabel width="150px">
              <strong style={{fontSize:"1.5rem"}}>Deduction Per Generation</strong>
            </FormLabel>
            <div style={{paddingTop: "10px"}}>
              <Input
                placeholder="Deduction Per Generation"
                value={misData.deductionPerGeneration}
                onChange={(e) =>
                  handleSingleField(
                    setMisData,
                    misData,
                    "deductionPerGeneration",
                    e.target.value
                  )
                }
              />
            </div>

            <Divider />

            <FormLabel width="150px">
              <strong style={{fontSize:"1.5rem"}}>Deduction per closure</strong>
            </FormLabel>
            <div style={{paddingTop: "10px"}}>
              <Input
                placeholder="Deduction per closure"
                value={misData.deductionPerClosure}
                onChange={(e) =>
                  handleSingleField(
                    setMisData,
                    misData,
                    "deductionPerClosure",
                    e.target.value
                  )
                }
              />
            </div>
            <Divider />

            <FormLabel width="150px">
              <strong style={{color:"red", fontSize:"2rem"}}>Incentive Calculation</strong>
            </FormLabel>
            {misData.incentive.map((item, index) => (
              <>
                {renderLabel(index) }
                <div key={index} style={{ display: "flex", gap: "10px" }}>
                  <Input
                    placeholder="Low"
                    value={item.low}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "incentive",
                        index,
                        "low",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="High"
                    value={item.high}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "incentive",
                        index,
                        "high",
                        e.target.value
                      )
                    }
                  />
                  <Input
                    placeholder="Score"
                    value={item.score}
                    onChange={(e) =>
                      handleChange(
                        setMisData,
                        misData,
                        "incentive",
                        index,
                        "score",
                        e.target.value
                      )
                    }
                  />
                </div>
              </>
            ))}
            <Divider />
          </>
        }

        {
          selectedRole?.getTitle() === constants.roleTitle.zo && 
          <>
            {/* <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Field Ratio</strong>
              </FormLabel>
              {zoData.fieldRatio.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "fieldRatio",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "fieldRatio",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "fieldRatio",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>                
              ))}
            </div> */}

            <Divider />

            <div >
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Total Qc Done</strong>
              </FormLabel>
              {zoData.totalQcDone.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "totalQcDone",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "totalQcDone",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "totalQcDone",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>                
              ))}
            </div>

            <Divider />

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Success Rate</strong>
              </FormLabel>
              {zoData.successRate.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "successRate",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "successRate",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "successRate",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>                
              ))}
            </div>

            <Divider />

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>TAT</strong>
              </FormLabel>
              {zoData.tat.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "tat",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "tat",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "tat",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>                
              ))}              
            </div>

            <Divider/>

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Qc TAT</strong>
              </FormLabel>
              {zoData.qcTat.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "qcTat",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "qcTat",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "qcTat",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>                
              ))}   
            </div>

            <Divider />

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Re-Investigation Deduction</strong>
              </FormLabel>
              <div style={{paddingTop: "10x"}}>
                <div style={{display: 'flex', width: "100%"}}>
                  <Input
                    placeholder="Re-Investigation Deduction"
                    value={zoData.reinvestigationDeduction}
                    onChange={(e) =>
                      handleSingleField(
                        setZoData,
                        zoData,
                        "reinvestigationDeduction",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>
            
            <Divider />

            <div>
              <FormLabel width="150px">
                  <strong style={{color: "Red", fontSize:"2rem"}}>Incentive Calculation</strong>
              </FormLabel>
              {zoData.incentive.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "incentive",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "incentive",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setZoData,
                          zoData,
                          "incentive",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>                
              ))}  
            </div>
            <Divider />
          </>
        }

        {
          selectedRole?.getTitle() === constants.roleTitle.tl && 
          <>
            <div >
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Field Ratio</strong>
              </FormLabel>
              {tlData.fieldRatio.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "fieldRatio",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "fieldRatio",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "fieldRatio",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>

            <Divider />

            <div >
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Team Ratio</strong>
              </FormLabel>
              {tlData.teamRatio.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "teamRatio",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "teamRatio",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "teamRatio",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>

            <Divider />

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Success Rate</strong>
              </FormLabel>
              {tlData.successRate.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "successRate",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "successRate",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "successRate",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>

            <Divider />

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>TAT</strong>
              </FormLabel>
              {tlData.tat.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "tat",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "tat",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "tat",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}         
            </div>

            <Divider/>

            <div>
              <FormLabel width="150px">
                  <strong style={{color: "Red", fontSize:"2rem"}}>Incentive Calculation</strong>
              </FormLabel>
              {tlData.incentive.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "incentive",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "incentive",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setTlData,
                          tlData,
                          "incentive",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>
            <Divider />
          </>
        }

        {
          selectedRole?.getTitle() === constants.roleTitle.ca && 
          <>
            <div >
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Total Closed Cases</strong>
              </FormLabel>
              {caData.totalClosedCases.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "totalClosedCases",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "totalClosedCases",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "totalClosedCases",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>

            <Divider />

            <div >
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Hygine</strong>
              </FormLabel>
              {caData.hygiene.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "hygiene",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "hygiene",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "hygiene",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>

            <Divider />

            <div>
              <FormLabel width="150px">
                  <strong style={{color: "Red", fontSize:"2rem"}}>Incentive Calculation</strong>
              </FormLabel>
              {caData.incentive.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "incentive",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "incentive",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setCaData,
                          caData,
                          "incentive",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>
            <Divider />
          </>
        }

        {
          selectedRole?.getTitle() === constants.roleTitle.oh && 
          <>
            <div >
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Field Ratio</strong>
              </FormLabel>
              {ohData.fieldRatio.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "fieldRatio",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "fieldRatio",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "fieldRatio",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>

            <Divider />

            <div >
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Team Ratio</strong>
              </FormLabel>
              {ohData.teamRatio.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "teamRatio",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "teamRatio",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "teamRatio",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>

            <Divider />

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Success Rate</strong>
              </FormLabel>
              {ohData.successRate.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "successRate",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "successRate",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "successRate",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))}
            </div>

            <Divider />

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>TAT</strong>
              </FormLabel>
              {ohData.tat.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "tat",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "tat",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "tat",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))} 
            </div>

            <Divider/>

            <div>
              <FormLabel width="150px">
                <strong style={{fontSize:"1.5rem"}}>Re-Investigation Deduction</strong>
              </FormLabel>
              <div style={{paddingTop: "10px"}}>
                <div style={{display: 'flex', width: "100%"}}>
                  <Input
                    placeholder="Re-Investigation Deduction"
                    value={ohData.reinvestigationDeduction}
                    onChange={(e) =>
                      handleSingleField(
                        setOhData,
                        ohData,
                        "reinvestigationDeduction",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>
            
            <Divider />

            <div>
              <FormLabel width="150px">
                  <strong style={{color: "Red", fontSize:"2rem"}}>Incentive Calculation</strong>
              </FormLabel>
              {ohData.incentive.map((item, index) => (
                <>
                  {renderLabel(index) }
                  <div key={index} style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Low"
                      value={item.low}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "incentive",
                          index,
                          "low",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="High"
                      value={item.high}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "incentive",
                          index,
                          "high",
                          e.target.value
                        )
                      }
                    />
                    <Input
                      placeholder="Score"
                      value={item.score}
                      onChange={(e) =>
                        handleChange(
                          setOhData,
                          ohData,
                          "incentive",
                          index,
                          "score",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </>
              ))} 
            </div>
            <Divider />
          </>
        }

        {
          selectedRole !== null && 
          <Button primary loading={loading} onClick={handleSubmit}>Submit</Button>
        }

      </Segment>

    </>
  )
}

export default IncentiveSegment
